<template>
  <div class="tabbar">
    <ul>
      <li>
        <a @click="handleConfirm">
          <p>
            <img
              width="24"
              src="@/assets/images/game.svg"
              alt="" />
          </p>
          <span>{{ info.language_list.footer.games }}</span></a
        >
      </li>
      <li class="active">
        <a>
          <p>
            <img
              width="24"
              src="@/assets/images/app.svg"
              alt="" />
          </p>
          <span>{{ info.language_list.footer.apps }}</span></a
        >
      </li>
      <li>
        <a @click="handleConfirm">
          <p>
            <img
              width="24"
              src="@/assets/images/file.svg"
              alt="" />
          </p>
          <span>{{ info.language_list.footer.movies }}</span></a
        >
      </li>
      <li>
        <a @click="handleConfirm">
          <p>
            <img
              width="24"
              src="@/assets/images/book.svg"
              alt="" />
          </p>
          <span>{{ info.language_list.footer.books }}</span></a
        >
      </li>
      <li>
        <a @click="handleConfirm">
          <p>
            <img
              width="24"
              src="@/assets/images/child.svg"
              alt="" />
          </p>

          <span>{{ info.language_list.footer.kids }}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const info = computed(() => store.state.appInfo);


const emit = defineEmits(['confirm']);

const handleConfirm = () => {
  emit('confirm');
};
</script>

<style lang="scss" scoped>
.tabbar {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 3;
  height: 56px;
  background-color: #fff;
  border-top: 1px solid rgb(218, 220, 224);
  ul {
    display: flex;
    height: 56px;
    align-items: center;
    justify-content: center;
  }
  ul li {
    flex: 1;
    text-align: center;
    overflow: hidden;
  }
  ul span {
    display: block;
    white-space: nowrap;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }
  ul li p {
    width: 24px;
    height: 24px;
    margin: 0 auto 2px;
    overflow: hidden;
  }
  ul li a {
    color: rgb(95, 99, 104);
    display: block;
    margin: 0 auto;
    width: 50px;
  }
  ul li a:hover,
  ul li.active a {
    color: var(--main-color);
  }
  ul li a:hover img,
  ul li.active a img {
    filter: drop-shadow(var(--main-color) 80px 0);
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    transform: translateX(-80px);
  }
}
</style>
